module.exports = __webpack_public_path__ + "static/media/freeTypingLessons.668c62c0.png";